/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveMemberFromTeamPlannerRequest } from '../../models/remove-member-from-team-planner-request';

export interface RemoveMemberFromTeamPlanner$Params {
  id: string;
      body: RemoveMemberFromTeamPlannerRequest
}

export function removeMemberFromTeamPlanner(http: HttpClient, rootUrl: string, params: RemoveMemberFromTeamPlanner$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, removeMemberFromTeamPlanner.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

removeMemberFromTeamPlanner.PATH = '/v0/teamPlanners/{id}/remove-member';
